export default {"src":"/_next/static/media/roadwise-warranty-logo-light-fr.a52f7f5a.svg","height":46,"width":109,"blurWidth":0,"blurHeight":0};